import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-5357891-15',
  linkers: ['localhost', 'macrealty.com', 'firebaseapp.com'],
})
